import { Input, Form, DatePicker, Tooltip } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { InputType, EditableCellProps } from "types/table.types";
import { AutoCompleteCommon, InputCommon } from "components/common";

const { TextArea } = Input;

const EditableCell = <T extends Record<string, unknown>>({
  editing,
  dataIndex,
  // title,
  inputType,
  // record,
  // index,
  children,
  selectOptions,
  rules = [],
  ...restProps
}: EditableCellProps<T>) => {
  const getInputNode = () => {
    switch (inputType) {
      case InputType.NUMBER:
        return (
          <InputCommon
            type="number"
            fullWidth={false}
            className=" !w-fit !max-w-[100px]"
            min={0}
          />
        );
      case InputType.SELECT:
        return (
          <AutoCompleteCommon
            options={selectOptions}
            className=" !w-fit !max-w-[150px] "
            sizeSelect="xs2"
            allowClear={false}
          />
        );
      case InputType.DATE:
        return (
          <DatePicker className="!w-auto !max-w-[120px]" format="DD/MM/YYYY" />
        );
      case InputType.TEXTAREA:
        return <TextArea rows={2} className="!w-full" />;
      case InputType.TEXT:
      default:
        return <InputCommon fullWidth={false} className="!max-w-[100px]" />;
    }
  };

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item noStyle shouldUpdate>
          {(form) => {
            const fieldError = form.getFieldError(dataIndex as string);
            const hasError = fieldError && fieldError.length > 0;

            return (
              <Form.Item
                name={dataIndex as string}
                style={{ margin: 0 }}
                rules={rules}
                validateTrigger={["onChange", "onBlur"]}
              >
                <div className="flex items-center gap-1">
                  <Form.Item name={dataIndex as string} noStyle rules={rules}>
                    {getInputNode()}
                  </Form.Item>
                  {hasError && (
                    <Tooltip
                      title={fieldError.join(", ")}
                      color="var(--sematicErrorColor500)"
                      placement="topLeft"
                    >
                      <ExclamationCircleFilled
                        style={{
                          color: "var(--sematicErrorColor500)",
                          fontSize: "14px",
                          cursor: "help",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  )}
                </div>
              </Form.Item>
            );
          }}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
